import type { QueryOptions } from '@tanstack/react-query';

import { http } from '@/api/instance';
import { getQueryParameters } from '@/api/query';

export const roleAPI = {
  list: ({ ...params }: Record<string, string | number>) =>
    http.get<ListResultsPageSize<Roles>>('/api/info/roles', { params }).then(({ data }) => data),
  create: (data: RolePayload) => http.post<unknown>(`/api/add/roles`, { data }),
  update: (id: number | string, data: RolePayload) => http.put<unknown>(`/api/edit/roles/${id}`, { data }),
  delete: (id: number | string) => http.delete<unknown>(`/api/delete/roles/${id}`),
  detail: (id: number | string) => http.get<Roles>(`/api/info/roles/${id}`).then(({ data }) => data),
};

export const roleQuery = {
  list: (params: QueryParams<Partial<SearchFormData>>) =>
    ({
      queryKey: ['GetRoleList', params] as const,
      queryFn: () => roleAPI.list(getQueryParameters(params)),
    }) as const satisfies QueryOptions,
  detail: (id: number | string) =>
    ({
      queryKey: ['GetRoleDetail', id] as const,
      queryFn: () => roleAPI.detail(id),
    }) as const satisfies QueryOptions,
};
